<template>
  <b-overlay
    variant="white"
    :show="isLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <b-row class="match-height">
      <b-col cols="12">
        <b-card :title="this.$route.meta.title">
          <b-alert
            v-height-fade
            dismissible
            v-model="showDismissibleAlert"
            fade
            class="mb-2"
            variant="danger"
            v-id="showDismissibleAlert == true"
          >
            <div class="alert-body mb-2">
              <span class="text-danger">{{ messages }}</span>
            </div>
          </b-alert>

          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(save)">
              <b-card-body class="p-0">
                <!-- Biaya -->
                <!-- <b-form-group label="Biaya" label-for="cost"> -->
                <b-form-group>
                  <label label-for="cost">Biaya <span class="text-danger">*</span></label>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Biaya"
                    rules="required"
                  >
                  <vue-number
                    v-model="model.cost"
                    id="cost"
                    class="form-control"
                    placeholder="Masukkan Biaya"
                    :prefix="'Rp '"
                    :decimal="','"
                    :separator="'.'"
                    :precision="0"
                    :masked="false"
                    :accept-negative="false"
                    :is-integer="true"
                    @keypress.native="NumbersOnly"
                  ></vue-number>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
                  <!-- <vue-numeric 
                    id="cost"
                    v-model="model.cost"
                    @keypress.native="numbersOnly"
                    class="form-control"
                    placeholder="Masukkan Biaya"
                    currency="Rp"
                    separator="."
                  ></vue-numeric>-->
                </b-form-group>

                <!-- Alat Transportasi -->
                <!-- <b-form-group
                  label="Alat Transportasi"
                  label-for="transportation"
                > -->
                <b-form-group>
                  <label label-for="transportation">Alat Transportasi <span class="text-danger">*</span></label>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Alat Transportasi"
                    rules="required"
                  >
                    <b-form-select
                      id="transportation"
                      v-model="model.transportation"
                      :options="transportationOptions"
                    ></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>

                <!-- Upload Kwitansi -->
                <!-- <b-form-group label="Upload Kwitansi" label-for="inputKwitansi"> -->
                <b-form-group>
                  <label label-for="inputKwitansi">Upload Kwitansi <span class="text-danger">*</span></label>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Kwitansi"
                    :rules="metaAction === 'edit' ? '' : `required`"
                  >
                    <b-form-file
                      id="inputKwitansi"
                      v-model="kwitansi"
                      :placeholder="placeholderFile"
                      drop-placeholder="Taruh file disini..."
                      accept=".jpg, .png, .gif, .doc, .docx, .pdf"
                      @change="handleUploadKwitansi"
                    ></b-form-file>
                    <b-link
                      v-if="currentReceiptUrl"
                      :href="currentReceiptUrl"
                      target="_blank"
                      class="d-block text-info mt-1"
                    >
                      {{ currentReceiptUrl.split('/').at(-1) }}
                    </b-link>
                    <p class="text-gray mb-0" style="font-size: 0.857rem">Unggah file dalam format JPG, PNG, GIF, PDF, DOCX, atau DOC (batas maks. 10 MB).</p>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-card-body>
              <b-card-footer align="right" class="px-0">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-secondary"
                  @click="goBack"
                >
                  Kembali
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  :disabled="loadingUpload"
                  class="ml-1"
                  variant="primary"
                  type="submit"
                >
                  Simpan
                </b-button>
              </b-card-footer>
            </b-form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BCard,
  BCardBody,
  BCardFooter,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormFile,
  BLink,
  BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import VueNumberFormat from '@core/components/vue-number-format';

export default {
  name: 'SppdTransportationForm',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BCardBody,
    BCardFooter,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormFile,
    BLink,
    BOverlay,
    VueNumberFormat,
  },
  directives: { Ripple },
  data() {
    const { sppdId, sppdTransportationId, actionTab, beforeLink } = this.$route.params
    const { action: metaAction } = this.$route.meta

    return {
      sppdId,
      sppdTransportationId,
      actionTab,
      beforeLink,
      metaAction,
      config: {
        api: '/sppd/transportation',
        redirect: `/biaya-transportasi/${sppdId}`,
        redirectDetail: `/manajemen-sppd/${sppdId}/detail`,
      },
      model: {
        cost: 0,
        transportation: null,
        document: '',
      },
      currentReceiptUrl: null,
      transportationOptions: [{ value: null, text: 'Pilih Alat Transportasi' }],
      kwitansi: null,
      placeholderFile: 'Pilih file...',
      loadingUpload: false,
      messages: '',
      isLoading: false,
    }
  },
  mounted() {
    if (this.metaAction === 'edit') {
      this.getTransportation()
    }

    this.getListTransportations()
  },
  methods: {
    getListTransportations() {
      this.isLoading = true
      axios.get('/misc/transportations').then(res => {
        const options = res.data.data.map(({ id, name }) => ({
          value: id,
          text: name,
        }))
        this.transportationOptions = [...this.transportationOptions, ...options]
        this.isLoading = false
      })
      .catch(error => {
        this.isLoading = false
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    numbersOnly(event) {
      const evt = event || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    handleUploadKwitansi(event) {
      this.loadingUpload = true
      const file = event.target.files[0]

      if (file.size > 10 * 1024 * 1024) {
        this.placeholderFile = 'Pilih file disini...'
        this.$bvToast.toast(
          'Ukuran File Melebihi 10 MB, Silahkan Upload Kembali dengan ukuran file yang sesuai',
          {
            title: 'Tambah Transportasi',
            variant: 'danger',
            solid: true,
          },
        )

        return
      }

      const formData = new FormData()
      formData.append('file', file)
      formData.append('folder', this.$route.query.folder)
      formData.append('type', 'transportasi')

      axios
        .post('/misc/upload-file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          this.loadingUpload = false
          this.model.document = res.data.filename
        })
        .catch((e) => {
          this.loadingUpload = false
          // console.error(err.response)
          if(typeof e.response.data.message === 'object'){
            this.messages = e.response.data.message.errors[0].msg
          } else {
            this.messages = e.response.data.message
          }
        })
    },
    save() {
      const { transportation, cost, document } = this.model
      const data = {
        sppd_id: this.sppdId,
        transportation_id: transportation,
        total_cost: cost,
        document,
      }
      this.isLoading = true
      if (this.metaAction === 'store') {
        axios
          .post(`${this.config.api}`, data)
          .then(() => {
            this.isLoading = false
            this.goBack({
              query: {
                event: 'success',
                title: 'Berhasil',
                text: 'Biaya transportasi berhasil ditambahkan',
              },
            })
          })
          .catch(error => {
            this.isLoading = false
            console.error(error)

            var message = "";
            if(typeof error.response.data.message === 'object'){
              message = error.response.data.message.errors[0].msg
            } else {
              message = error.response.data.message
            }
            this.makeToast('danger', "Terjadi Kesalahan", message)
          });
      } else {
        axios
          .put(`${this.config.api}/${this.sppdTransportationId}`, data)
          .then(() => {
            this.isLoading = false
            this.goBack({
              query: {
                event: 'success',
                title: 'Berhasil',
                text: 'Biaya transportasi berhasil diubah',
              },
            })
          })
          .catch(error => {
            this.isLoading = false
            console.error(error)

            var message = "";
            if(typeof error.response.data.message === 'object'){
              message = error.response.data.message.errors[0].msg
            } else {
              message = error.response.data.message
            }
            this.makeToast('danger', "Terjadi Kesalahan", message)
          });
      }
    },
    goBack({ query }) {
      if(this.beforeLink == 'detail-sppd'){
        this.$router.push({
          path: this.config.redirectDetail,
          query: { ...query, activeTab: this.actionTab },
        })
      } else {
        this.$router.push({
          path: this.config.redirect,
          query,
        })
      }
    },
    getTransportation() {
      axios.get(`${this.config.api}/${this.sppdTransportationId}`).then(res => {
        const {
          total_cost: cost,
          transportation_id: transportation,
          document,
          file,
        } = res.data.data

        this.currentReceiptUrl = file

        this.model = {
          cost,
          transportation,
          document,
        }
      })
      .catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    makeToast(variant = null, title = 'Title here...', text = 'Text here...') {
      this.$bvToast.toast(text, {
        title,
        variant,
        solid: true,
      })
    },
  },
}
</script>

<style>
.kwitansi-filename {
  margin-top: 4px;
  font-size: 12px;
  font-style: italic;
}
</style>
